import { ETrialGenerationStatus } from '../types';

type OrganisationLike = {
  id: string | number;
  trial?: {
    setup_completed?: boolean;
    generation_status?: string | null;
  } | null;
};

export const buildingPath = (organisationId: string | number) => `/auth/building/${organisationId}`;

const BUILDING_STATUSES: string[] = [
  ETrialGenerationStatus.GATE_RUNNING,
  ETrialGenerationStatus.GATE_FAILED,
];

/**
 * The progress screen owns the organisation while the generator's gate runs
 * (or failed). Everything after gate_done is the product.
 */
export const isTrialBuilding = (organisation?: OrganisationLike | null): boolean => (
  !!organisation?.trial?.generation_status
  && BUILDING_STATUSES.includes(organisation.trial.generation_status)
);

/**
 * A trial that still needs the setup wizard: not set up and never generated.
 * Organisations the generator is building (or has built) skip the wizard.
 */
export const isTrialAwaitingSetup = (organisation?: OrganisationLike | null): boolean => {
  const trial = organisation?.trial;

  if (!trial || trial.setup_completed) return false;

  const status = trial.generation_status;

  return !status || status === ETrialGenerationStatus.NOT_STARTED;
};

/**
 * Where a logged-in user should land for a trial organisation, or null when
 * the normal organisation selection applies.
 */
export const getTrialRedirect = (organisation?: OrganisationLike | null): string | null => {
  if (!organisation) return null;
  if (isTrialBuilding(organisation)) return buildingPath(organisation.id);
  if (isTrialAwaitingSetup(organisation)) return `/auth/registration?org=${organisation.id}`;

  return null;
};
